/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Link, makeStyles} from '@material-ui/core';
import {translate} from '@ion/core/src/locale/locale';
import Breadcrumb from '@ion/dls/src/components/breadcrumbs/Breadcrumbs';
import {dlsAlt, dlsColor} from '@ion/dls/src/theme/theme';
import Divider from '../../../components/divider/Divider';
import {LabelTypography} from '../../../typography/LabelTypography';

export interface FindNearbyBreadcrumbType {
  label: string;
  fallbackLabel: string;
  onBackClick?: void | (() => void) | ((e: any) => void);
}

const useStyles = makeStyles((theme) => ({
  nameLabel : {
    whiteSpace   : 'nowrap',
    overflow     : 'hidden',
    textOverflow : 'ellipsis',
    maxWidth     : '125px',
    padding      : '0px !important',
    color        : dlsColor('grey3'),
    ...dlsAlt('typography', 'cta2')
  },
  breadcrumbs : {
    padding : '10px 10px 10px 20px'
  },
  assetBreadcrumb : {
    cursor         : 'pointer',
    textDecoration : 'none !important',
    color          : `${dlsColor('grey4')}`
  },
  findNearbyText : {
    textDecoration : 'none',
    pointerEvents  : 'none',
    textTransform  : 'uppercase',
    fontWeight     : 700,
    color          : `${dlsColor('grey3')}`
  }
}));

export const FindNearbyBreadcrumbs = ({
  label,
  fallbackLabel,
  onBackClick
}: FindNearbyBreadcrumbType) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.breadcrumbs}>
        <Breadcrumb height={'10px'}>
          <LabelTypography className={classes.nameLabel} variantType='label2'>
            <Link className={classes.assetBreadcrumb}
              onClick={onBackClick}>
              {label || fallbackLabel}
            </Link>
          </LabelTypography>
          <LabelTypography variantType='label2'>
            <span className={classes.findNearbyText}>
              {`${translate('tracking:breadcrumb.findNearby')}`}
            </span>
          </LabelTypography>
        </Breadcrumb>
      </div>
      <Divider />
    </>
  );
};

export default FindNearbyBreadcrumbs;
